module.exports = require("@bechtel/client-assets/dist/images/as-unauthorized-logo.svg");